<template>
  <KanbanColumn
    class="order-kanban-column"
    :column="column"
    :loading="column.loading_status"
    @moved="$emit('moved', $event)"
  >
    <template #header>
      <OrderKanbanHeader
        :data="column"
        @open-nested="$emit('open-nested', column)"
        @refresh="$emit('refresh', column)"
      >
        <OrderKanbanSearch 
          :column="column"
          :search-result="searchResult"
          @search="$emit('search', column)"
        />
      </OrderKanbanHeader>
    </template>

    <template #item>
      <OrderKanbanItem
        v-for="item in column.items"
        :item="item"
        :key="item.id"
        :isDragDisabled="(column.kanban_meta && column.kanban_meta.disable_drag) || false"
        @click="$emit('click-item', $event)"
      />

      <Observer
        v-if="observerView(column)"
        @intersect="$emit('intersect', column)"
      />
    </template>
    <template #nested>
      <div
        v-show="
          column.kanban_meta.all_users_opened &&
          column.nested_columns.length > 0
        "
        class="order-kanban-column__nested"
      >
        <h3 class="order-kanban-column__title">
          {{ column.kanban_meta.reference_status_name }}
        </h3>

        <div class="d-flex h-100 overflow-hidden">
          <OrderKanbanColumn
            v-for="(nested, index) in column.nested_columns"
            :key="index"
            :column="nested"
            :search-result="searchResult"
            @refresh="$emit('refresh', $event)"
            @open-nested="$emit('open-nested', $event)"
            @search="$emit('search', $event)"
            @searchAll="$emit('searchAll', $event)"
            @intersect="$emit('intersect', $event)"
            @click-item="$emit('click-item', $event)"
            @moved="$emit('moved', $event)"
          />
        </div>
      </div>
    </template>
  </KanbanColumn>
</template>

<script>
import KanbanColumn from "@components/ui/Kanban/KanbanColumn";
import OrderKanbanHeader from "@components/orderKanban/OrderKanbanHeader";
import OrderKanbanItem from "@components/orderKanban/OrderKanbanItem";
import OrderKanbanSearch from "@components/orderKanban/OrderKanbanSearch";
import Observer from "@components/observer/Observer";

export default {
  name: "OrderKanbanColumn",

  components: {
    KanbanColumn,
    OrderKanbanHeader,
    OrderKanbanItem,
    OrderKanbanSearch,
    Observer,
  },

  props: {
    column: {
      type: Object,
      required: true,
    },
    searchResult: {
      type: String,
      default: '',
    },
  },

  watch: {
    async searchResult() {
      if (this.searchResult !== '') {
        this.column.search = this.searchResult;
        this.column.nested_columns.forEach(nested => {
          nested.search = this.searchResult;
        });
        if (this.column !== null && this.column !== undefined) {
          await this.$emit('searchAll', this.column);
        }
      } else if (this.searchResult === '') {
        this.column.search = '';
        this.column.nested_columns.forEach(nested => {
          nested.search = '';
        })
      }
    }
  },

  methods: {
    openNestedColumns(column) {
      column.kanban_meta.all_users_opened =
        !column.kanban_meta.all_users_opened;

      if (column.nested_columns.every((el) => !el.meta.loaded)) {
        this.$emit("fetchAll", this.column.nested_columns);
      }
    },

    observerView(column) {
      const meta = !!column.search ? "search_meta" : "meta";
      if (!!column[meta].to === false) {
        return false;
      } else {
        return column[meta].to !== column[meta].total;
      }
    },
  },
};
</script>

<style lang="scss" scoped src="~/components/orderKanban/OrderKanbanColumn.scss" />
